<div class="loaderContent">
  <ngx-ui-loader [loaderId]="componentID"></ngx-ui-loader>

  <div>
    <dx-toolbar>
      <dxi-item location="before">
        <dx-button
          text="Edit"
          type="default"
          [disabled]="isLoading || canAddOrEdit"
          (onClick)="onEdit()"
        ></dx-button>
      </dxi-item>
      <dxi-item location="before" style="margin-left: 10px">
        <dx-button
          text="Save"
          [disabled]="isLoading || !canAddOrEdit"
          type="normal"
          (onClick)="saveChanges($event)"
        ></dx-button>
      </dxi-item>
      <dxi-item location="before">
        <dx-button
          text="Cancel"
          [disabled]="isLoading || !canAddOrEdit"
          type="danger"
          (onClick)="cancelChanges($event)"
        ></dx-button>
      </dxi-item>
      <dxi-item location="before" style="margin-left: 25px">
        <dx-button
          text="Password Reset"
          [disabled]="isLoading || canAddOrEdit"
          [visible]="authenticatedUser?.isAdmin"
          type="default"
          (onClick)="passwordReset()"
        ></dx-button>
      </dxi-item>

      <dxi-item location="before">
        <dx-button
          text="User Manager"
          type="default"
          (onClick)="goUserManager()"
          [visible]="authenticatedUser?.isAdmin"
        ></dx-button>
      </dxi-item>
    </dx-toolbar>

    <div style="display: flex; flex-wrap: wrap; padding-top: 10px; justify-content: center">
      <div class="border dx-theme-border-color" style="padding: 10px; margin: 5px">
        @if (displayMode === 'D' || !authenticatedUser?.isAdmin) {
          <div>
            <table>
              <tr>
                <td class="grid-value">
                  @if (user.is_active) {
                    <div style="color: green">User is Active</div>
                  }
                  @if (!user.is_active) {
                    <div style="color: red">User is Inactive</div>
                  }
                </td>
              </tr>
            </table>
          </div>
        }
        @if (displayMode !== 'D' && authenticatedUser?.isAdmin) {
          <div>
            <dx-check-box [(value)]="user.is_active" text="Active User"></dx-check-box>
          </div>
        }
        <table style="margin-right: 20px; width: 400px">
          <tr>
            <td class="grid-label">User Name</td>
            <td class="grid-value">
              @if (displayMode === 'D') {
                <div>{{ user.user_name }}</div>
              }
              @if (canAddOrEdit) {
                <dx-text-box
                  style="text-transform: uppercase !important"
                  [(value)]="user.user_name"
                  >
                  <dx-validator [validationGroup]="validationGroup">
                    <dxi-validation-rule
                      type="required"
                      message="Unique User ID is required"
                    ></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              }
            </td>
          </tr>
          <tr>
            <td class="grid-label">First Name</td>
            <td class="grid-value">
              @if (displayMode === 'D') {
                <div>{{ user.first_name }}</div>
              }
              @if (canAddOrEdit) {
                <dx-text-box [(value)]="user.first_name">
                  <dx-validator [validationGroup]="validationGroup">
                    <dxi-validation-rule
                      type="required"
                      message="First Name is required"
                    ></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              }
            </td>
          </tr>
          <tr>
            <td class="grid-label">Last Name</td>
            <td class="grid-value">
              @if (displayMode === 'D') {
                <div>{{ user.last_name }}</div>
              }
              @if (canAddOrEdit) {
                <dx-text-box [(value)]="user.last_name">
                  <dx-validator [validationGroup]="validationGroup">
                    <dxi-validation-rule
                      type="required"
                      message="Last Name is required"
                    ></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              }
            </td>
          </tr>
          <tr>
            <td class="grid-label">Email</td>
            <td class="grid-value">
              @if (displayMode === 'D') {
                <div>{{ user.email }}</div>
              }
              @if (canAddOrEdit) {
                <dx-text-box [(value)]="user.email">
                  <dx-validator [validationGroup]="validationGroup">
                    <dxi-validation-rule
                      type="required"
                      message="Unique Email is required"
                    ></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              }
            </td>
          </tr>
          <tr>
            <td class="grid-label">Agency</td>
            <td class="grid-value">
              @if (displayMode === 'D' || !authenticatedUser?.isAdmin) {
                <div>{{ agency_name }}</div>
              }
              @if (canAddOrEdit && authenticatedUser?.isAdmin) {
                <dx-select-box
                  [dataSource]="agencyList"
                  [(value)]="user.agency_id"
                  valueChangeEvent="keyup blur change focusout"
                  displayExpr="sName"
                  valueExpr="gAgencyID"
                  >
                  <dx-validator [validationGroup]="validationGroup">
                    <dxi-validation-rule
                      type="required"
                      message="Agency is required"
                    ></dxi-validation-rule>
                  </dx-validator>
                </dx-select-box>
              }
            </td>
          </tr>
          <tr>
            <td class="grid-label">Receive Daily New Payment Summaries</td>
            <td class="grid-value">
              <tti-check-box
                [editMode]="displayMode !== 'D'"
                [(value)]="user.send_new_payment_notification"
              ></tti-check-box>
            </td>
          </tr>
        </table>
      </div>

      <div class="border dx-theme-border-color" style="padding: 10px; margin: 5px">
        <table style="margin-right: 20px; width: 400px">
          <tr>
            <td class="grid-label">Phone</td>
            <td class="grid-value">
              @if (displayMode === 'D') {
                <div>{{ user.phone1 }}</div>
              }
              @if (canAddOrEdit) {
                <dx-text-box [(value)]="user.phone1"> </dx-text-box>
              }
            </td>
          </tr>
          <tr>
            <td class="grid-label">Phone Alt</td>
            <td class="grid-value">
              @if (displayMode === 'D') {
                <div>{{ user.phone2 }}</div>
              }
              @if (canAddOrEdit) {
                <dx-text-box [(value)]="user.phone2"> </dx-text-box>
              }
            </td>
          </tr>
          <tr>
            <td class="grid-label">Address</td>
            <td>
              @if (displayMode === 'D') {
                <div>{{ user.address1 }}</div>
              }
              @if (canAddOrEdit) {
                <dx-text-box [(value)]="user.address1"> </dx-text-box>
              }
            </td>
          </tr>
          <tr>
            <td class="grid-label"></td>
            <td class="grid-value">
              @if (displayMode === 'D') {
                <div>{{ user.address2 }}</div>
              }
              @if (canAddOrEdit) {
                <dx-text-box [(value)]="user.address2"> </dx-text-box>
              }
            </td>
          </tr>
          <tr>
            <td class="grid-label">City</td>
            <td class="grid-value">
              @if (displayMode === 'D') {
                <div>{{ user.city }}</div>
              }
              @if (canAddOrEdit) {
                <dx-text-box [(value)]="user.city"> </dx-text-box>
              }
            </td>
          </tr>
          <tr>
            <td class="grid-label">State</td>
            <td class="grid-value">
              @if (displayMode === 'D') {
                <div>{{ user.state }}</div>
              }
              @if (canAddOrEdit) {
                <dx-text-box [(value)]="user.state"> </dx-text-box>
              }
            </td>
          </tr>
          <tr>
            <td class="grid-label">Zip</td>
            <td class="grid-value">
              @if (displayMode === 'D') {
                <div>{{ user.zip_code }}</div>
              }
              @if (canAddOrEdit) {
                <dx-text-box [(value)]="user.zip_code"> </dx-text-box>
              }
            </td>
          </tr>
        </table>
      </div>

      <div class="border dx-theme-border-color" style="padding: 10px; margin: 5px; width: 400px">
        <table style="margin-right: 20px; width: 100%">
          <tr>
            <td class="grid-label" style="vertical-align: text-top">Signature</td>
            <td>
              @if (displayMode === 'D') {
                <div>{{ user.signature }}</div>
              }
              @if (canAddOrEdit) {
                <dx-text-area height="200px" [(value)]="user.signature"></dx-text-area>
              }
            </td>
          </tr>
        </table>
      </div>

      @if (authenticatedUser && authenticatedUser.isAdmin) {
        <div
          class="border dx-theme-border-color"
          style="margin: 5px; max-width: 500px"
          >
          <app-user-role-select #roleSelect [user]="user" [displayMode]="displayMode"></app-user-role-select>
        </div>
      }

      <div class="border dx-theme-border-color" style="margin: 5px; min-width: 300px">
        <div
          class="border-header dx-theme-border-color-as-background-color dx-theme-border-color-as-background-color box-in-padding"
          >
          Status Messagse
        </div>
        <div style="display: flex; justify-content: center; padding: 10px">
          <dx-validation-summary
            #validationSummary
            [validationGroup]="validationGroup"
          ></dx-validation-summary>
        </div>
      </div>
    </div>
  </div>
</div>

<app-confirmation-dialog
  [visible]="showPasswordResetConfirmation"
  dialogTitle="Reset Password"
  confirmationText="Send Password Reset email to user {{ user.email }}, are you sure?"
  (completed)="onPasswordResetConfirmed($event)"
></app-confirmation-dialog>
